import { Button, ButtonGroup } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { RefetchFn } from "@msuite/ui/query";
import type { ProjectTimeline } from "@msuite/utils/projects";
import React from "react";
import { AddProjectTimelineNoteModal } from "@/modals/projects/add-project-timeline-note-modal";
import { CreateDiaryModal } from "@/modals/projects/create-diary-modal";

/** Props Interface */
interface ProjectTimelineMenuProps {
	projectId: string;
	refetch: RefetchFn;
	timeline: ProjectTimeline | undefined;
}

export function ProjectTimelineMenu({ projectId, refetch, timeline }: ProjectTimelineMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addNoteDisclosure = useDisclosure();
	const createDiaryDisclosure = useDisclosure();

	/** Guard */
	if (!timeline) return null;

	/** Render */
	return (
		<React.Fragment>
			<ButtonGroup isAttached={false}>
				<Button
					icon={<Icon name="Plus" />}
					onClick={addNoteDisclosure.onOpen}
					data-cy="project-timeline-add-note-button"
				>
					{t("notes.add_note")}
				</Button>
				<Button
					icon={<Icon name="Book" />}
					variant="primary"
					onClick={createDiaryDisclosure.onOpen}
				>
					{t("projects.create_diary")}
				</Button>
			</ButtonGroup>
			{addNoteDisclosure.isOpen && (
				<AddProjectTimelineNoteModal
					isOpen={addNoteDisclosure.isOpen}
					onClose={addNoteDisclosure.onClose}
					projectId={projectId}
					onComplete={refetch}
				/>
			)}
			{createDiaryDisclosure.isOpen && (
				<CreateDiaryModal
					isOpen={createDiaryDisclosure.isOpen}
					onClose={createDiaryDisclosure.onClose}
					timeline={timeline}
					projectId={projectId}
				/>
			)}
		</React.Fragment>
	);
}
